module.exports = {
  colorOrangeLight: "rgb(254, 120, 62)",
  colorOrangeBase: "rgb(250, 100, 35)",
  colorOrangeDark: "rgb(233, 89, 27)",
  colorBlueLight: "rgb(82, 199, 250)",
  colorBlueBase: "rgb(55, 170, 220)",
  colorBlueDark: "rgb(38, 147, 195)",
  colorGreenLight: "rgb(166, 232, 79)",
  colorGreenBase: "rgb(140, 202, 58)",
  colorGreenDark: "rgb(135, 184, 71)",
  colorYellowLight: "rgb(253, 225, 90)",
  colorYellowBase: "rgb(255, 211, 0)",
  colorYellowDark: "rgb(227, 175, 0)",
  colorRedLight: "rgb(244, 72, 70)",
  colorRedBase: "rgb(219, 47, 45)",
  colorRedDark: "rgb(200, 41, 45)",
  colorNavyLight: "rgb(79, 136, 253)",
  colorNavyBase: "rgb(40, 97, 212)",
  colorNavyDark: "rgb(34, 80, 173)",
  colorPurpleLight: "rgb(153, 68, 230)",
  colorPurpleBase: "rgb(124, 56, 185)",
  colorPurpleDark: "rgb(109, 49, 163)",
  colorMagentaLight: "rgb(214, 101, 180)",
  colorMagentaBase: "rgb(185, 70, 150)",
  colorMagentaDark: "rgb(157, 60, 128)",
  colorGrayBase: "rgb(85, 85, 90)",
  colorGray0: "rgb(0, 0, 0)",
  colorGray1: "rgb(65, 65, 70)",
  colorGray2: "rgb(85, 85, 90)",
  colorGray3: "rgb(110, 110, 115)",
  colorGray4: "rgb(130, 130, 135)",
  colorGray5: "rgb(170, 170, 175)",
  colorGray6: "rgb(190, 190, 195)",
  colorGray7: "rgb(210, 210, 215)",
  colorGray8: "rgb(225, 225, 230)",
  colorGray9: "rgb(242, 242, 245)",
  colorGray10: "rgb(255, 255, 255)",
  fontFamilyBase: "'Calibre', 'Gotham Narrow SSm A', 'Gotham Narrow SSm B', -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, Helvetica, sans-serif",
  fontFamilyMonospace: "'SFMono-Regular', Monaco, Consolas, 'Lucida Console', monospace",
  fontSize900: 28,
  fontSize800: 24,
  fontSize700: 21,
  fontSize600: 18,
  fontSize500: 17,
  fontSize400: 16,
  fontSize300: 15,
  fontSize200: 14,
  lineHeight600: "1.8em",
  lineHeight500: "1.6em",
  lineHeight400: "1.4em",
  lineHeight300: "1.2em",
  lineHeight200: "1em"
};